import {
  RuleParamSchema,
  ValidationMessageTemplate,
  ValidationRuleFunction,
  ValidationRuleSchema,
} from "vee-validate/dist/types/types"

import { forbiddenCharactersValidator } from "./forbiddenCharactersValidator"
import { customMessage } from "./validatorUtil"

export class ForbiddenCharactersSchema implements ValidationRuleSchema {
  validate: ValidationRuleFunction = (value, params: Record<string, any>) => {
    const found = forbiddenCharactersValidator(value, params)

    // エラーメッセージへの表示用にparamsに格納する
    params.found = found.join(" ")
    return found.length === 0
  }
  params: RuleParamSchema[] = ["found"] // messageへfoundを伝搬させるために必要
  message: ValidationMessageTemplate = (field: string, params?: Record<string, any>) => {
    return customMessage(field, params, ["found"])
  }
}
